'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const LoginPageFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#A78BFA"
      ariaLabel={t('LoginPage/FinalCTA/aria_label')}
      copy={{
        headlineA: t('LoginPage/FinalCTA/title1'),
        headlineB: t('LoginPage/FinalCTA/title2'),
        subhead: t('LoginPage/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('LoginPage/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('LoginPage/FinalCTA/cta_secondary'),
          href: `/${lang}/contact-us`,
        },
      }}
    />
  );
};

export default LoginPageFinalCTA;
